import IAdminTag from "../models/IAdminTag";
import { axiosInstance } from "./ServiceConstants";

class TagService {
    async generateTags(tagCount: number) {
        let requestData = new FormData();
        requestData.append("tagCount", tagCount.toString());
        await axiosInstance.post('api/tags/generate', requestData, {
            responseType: "blob"
        }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            const fileName = `tags.${tagCount}.csv`;
            link.setAttribute('download', fileName); //or any other extension
            document.body.appendChild(link);
            link.click();
        }).catch(error => {
            console.error(error);
        });

        // const url = URL.createObjectURL(new Blob[response.data]);
        // setFileUrl
    }
    async deleteTag(tagNumber: string): Promise<void> {
        await axiosInstance.delete('api/tags/' + tagNumber);
    }
    async getNextTag(): Promise<IAdminTag> {
        const response = await axiosInstance.post<IAdminTag>('api/tags/next');
        return response.data;
    }
    async searchTagsByTagNumber(tagNumber: string): Promise<IAdminTag[]> {
        let requestData = new FormData();
        requestData.append("tagNumber", tagNumber);
        const response = await axiosInstance.post<IAdminTag[]>('api/tags/search', requestData);
        return response.data;
    }

    async upsertTag(tag: IAdminTag): Promise<IAdminTag> {
        const response = await axiosInstance.post<IAdminTag>('api/tags/admin', tag);
        return response.data;
    }
}

const TagServiceInstance = new TagService();

export default TagServiceInstance;